import tailwindConfig from "tailwind.config";
import { LucideProps } from "lucide-react";
import { FC, ForwardRefExoticComponent, RefAttributes } from "react";

interface TagProps {
    label: string;
    icon?: ForwardRefExoticComponent<
        Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
      >;
    color?: string;
}

const Tag: FC<TagProps> = ({ icon, label }) => {
    const IconComponent = icon;
    return <div className={"flex bg-foreground/40 text-foreground px-1 py-0.5 rounded-xs gap-1 items-center"}>
        {IconComponent && <IconComponent className={'size-4'} />}
        {label}
    </div>
}

export { Tag };